export default __webpack_public_path__ + "static/hero-5df8fd4122c3247f028e9fa955b0ce8a.jpg";